// 会员套餐
export default {
    path: "/member",
    name: "member",
    component: () => import("../views/member/index.vue"),
    children: [
        // 会员选择套餐
        {
            path: "/member",
            name: "memberIndex",
            component: () => import("../views/member/memberPackage/index.vue"),
            meta: {
                isLogin: true,
            },
        },
        // 会员支付中心
        {
            path: "/member/paymentCenter",
            name: "member-paymentCenter",
            component: () => import("../views/member/paymentCenter/index.vue"),
            meta: {
                isLogin: true,
            },
        },
    ],
}